import { z } from 'zod';

export const dataplaneUpgradeApproveBody = z.object({
  version: z.string().optional().describe('Specific version to upgrade to'),
});

export type DataplaneUpgradeApproveBody = z.infer<typeof dataplaneUpgradeApproveBody>;
